// extracted by mini-css-extract-plugin
export default {"root":"yWjWtw1s","logo":"n5RV39oD","particles":"GVojJbOb","logoImg":"fftAZast"};